import { useState, useEffect, useCallback } from 'react';
import supabase from '../utils/supabaseClient';

const useFetchAssets = ({ logError }) => {
    const [assets, setAssets] = useState([]);
    const [assetKeys, setAssetKeys] = useState({});
    const [assetNames, setAssetNames] = useState([]);
    const [assetTickers, setAssetTickers] = useState([]);
    const [chartSymbols, setChartSymbols] = useState([]);
    const [fullNameKey, setFullNameKey] = useState({});
    const [assetsLoading, setAssetsLoading] = useState(true);

    const fetchAllAssets = useCallback(async ({ retry = true }) => {     
        const res = await supabase.from('asset_symbols').select('*');

        if (res?.error) {
            const error = new Error(res?.error?.message);
            logError(error.message, undefined, error);

            if (retry) {
                fetchAllAssets({ retry: false });

                return;
            }
    
            return;
        }

        const data = res?.data;
        const chartSymbols = data?.map(item => ({
            description: `${item.symbol} - ${item.name}`,
            exchange: 'NASDAQ',
            full_name: item.name,
            symbol: item.symbol,
            type: item.type,
        }));
        const objectsForSearch = data?.map(item => ({
            ...item,
            label: `${item.symbol} - ${item.name}`,
            value: item.symbol,
        }));

        const keys = {};
        data?.forEach((item) => keys[item.name?.toLowerCase()] = item.symbol);
        const names = data?.map(item => item.name?.toLowerCase());
        const tickers = data?.map(item => item.symbol);
        const fullNameKey = {};
        data?.forEach((item) => fullNameKey[item.symbol] = `${item.symbol} - ${item.name}`);

        
        setAssets(objectsForSearch);
        setAssetKeys(keys);
        setAssetNames(names);
        setAssetTickers(tickers);
        setChartSymbols(chartSymbols)
        setFullNameKey(fullNameKey);
        setAssetsLoading(false);
    }, []);

    useEffect(() => {
        fetchAllAssets({ retry: true });
    }, []);

    return {
        assets,
        assetKeys,
        assetNames,
        assetsLoading,
        assetTickers,
        chartSymbols,
        fullNameKey
    };
};

export default useFetchAssets;
